import React from "react";

import Main from "../components/Main";

import "react-h5-audio-player/lib/styles.css";

const Home = ({ songs, playSong, playingSong, error, playingTitle }) => {
  return (
    <>
      {error && (
        <div className="w-3/4  mx-auto text-center bg-pink-200 p-2 rounded">
          <h2 className="text-red-600 text-xl ">{error}</h2>
        </div>
      )}

      <div className="w-full md:ml-56 mx-auto h-full md:mt-0 mt-4">
        {/* songcontainer */}
        <h2 className="py-2 ml-4 text-left text-2xl  md:text-xl text-gray-500 border-b-2 border-pink-600 inline-block">
          {playingTitle && playingTitle}
        </h2>
        <div className="flex justify-center items-center w-full h-full mt-2">
          {songs ? (
            <Main songs={songs} playSong={playSong} />
          ) : (
            <h3 className="text-3xl md:text-2xl font-semibold text-pink-600 text-center w-1/2 mx-auto">
              Loading...
            </h3>
          )}
        </div>
      </div>
    </>
  );
};

export default Home;
